/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliveryOrderSchema } from "./deliveryOrderSchema.ts";

export const deliveryOrdersRetrievePathOrderIdSchema = z.uuid();

export const deliveryOrdersRetrieveStatus200Schema = deliveryOrderSchema;

export const deliveryOrdersRetrieveResponseSchema = deliveryOrdersRetrieveStatus200Schema;
